// src/pages/LoanEditPageExtended.js
import React, { useState, useEffect } from 'react';
import { Space, Spin, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import EditLoanFormExtended from '../components/loans/EditLoanFormExtended';
import Page from '../components/layout/Page';
import { getDetailedLoanInfo } from '../services/loanService';

const LoanEditPageExtended = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [loan, setLoan] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLoan = async () => {
      try {
        const data = await getDetailedLoanInfo(id);
        setLoan(data);
      } catch (error) {
        console.error('Error fetching loan:', error);
        message.error(t('loans.errors.loadingFailed'));
        navigate('/loans');
      } finally {
        setLoading(false);
      }
    };

    fetchLoan();
  }, [id, navigate, t]);

  if (loading) {
    return (
      <Page
        title={t('loan.edit.title')}
        subtitle={t('common.loading')}
      >
        <Space align="center" size="large">
          <Spin size="large" />
          <span>{t('common.loading')}</span>
        </Space>
      </Page>
    );
  }

  if (!loan) {
    return (
      <Page 
        title={t('loan.edit.title')}
        subtitle={t('loans.errors.notFound')}
      >
        <div>{t('loans.errors.notFound')}</div>
      </Page>
    );
  }

  return (
    <Page
      title={`${t('loan.edit.title')} (Buchhaltung): ${loan.process_number}`}
      subtitle={`${t('loan.fields.status')}: ${loan.status ? t(`loan.status.consultant.${loan.status.replace('LoanStatus.', '')}`) : '-'}`}
    >
      <Space direction="vertical" size="large" className="width-100">
        <EditLoanFormExtended 
          initialValues={loan}
          onSuccess={() => {
            message.success(t('loan.messages.updateSuccess'));
            navigate(`/loans/${id}?ts=${Date.now()}`);
          }}
        />
      </Space>
    </Page>
  );
};

export default LoanEditPageExtended;
